import { render, staticRenderFns } from "./dotsIcon.vue?vue&type=template&id=27d24692&"
import script from "./dotsIcon.vue?vue&type=script&lang=js&"
export * from "./dotsIcon.vue?vue&type=script&lang=js&"
import style0 from "./dotsIcon.vue?vue&type=style&index=0&id=27d24692&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports